import React, { useState } from 'react';
import { updateData } from '../../Helpers/requests';
import { r2_updateData } from '../../Helpers/r2_requests';

import { useNavigate } from 'react-router-dom';
import {
  Box,
  Grid,
  Typography,
  TextField,
  Divider,
  Button,
  Switch,
} from '@mui/material';

import { APIROOT } from '../../Helpers/configs';
import { GetAuth } from '../../Auth/AuthProvider';

import ConsumablesTypeAutoComplete from '../CommonComponents/ConsumablesTypeAutoComplete';
import { handleClose } from '../../Helpers/helpers';

const ConsumablesEdit = (props) => {
  const navigateBack = useNavigate();
  const enqNotification = GetAuth().Notification;
  const logout = GetAuth().signOut;
  const [forceUpdate, setForceUpdate] = useState(1);

  const thisRowData = props.thisRowData;
  const cancelEdit = props.cancelEdit;

  const [code, setCode] = useState(thisRowData.code);
  const [description, setDescription] = useState(thisRowData.description);
  const [type, setType] = useState(thisRowData.type);

  const handleChange = (event) => {
    switch (event.target.id) {
      case 'code':
        setCode(event.target.value);
        break;
      case 'description':
        setDescription(event.target.value);
        break;
      default:
        break;
    }
  };

  const dataBlob = {
    consumable: {
      code: code,
      description: description,
      type: type,
    },
  };

  const handleSave = () => {
    const path = '/admin/consumables';
    const updateType = 'consumable';
    const uri =
      thisRowData.id === undefined
        ? `/r2_consumables`
        : `/r2_consumables/${thisRowData.id}`;
    r2_updateData({
      uri: uri,
      dataBlob: dataBlob,
      cancelEdit: cancelEdit,
      setForceUpdate,
      navigateBack,
      path: '/admin/consumables',
      logout,
      enqNotification: enqNotification,
      updateMessage: 'Item updated',
      type: updateType,
    });
  };

  return (
    <Box sx={boxStyle}>
      <Grid container rowGap={2}>
        <Grid
          xs={12}
          md={8}
          sx={{
            border: '1px #c4c4c4 solid',
            // borderBottom: 'none',
            borderRadius: '15px 15px 0 0 ',
            padding: ' 10px 0 0 0 ',
          }}
          item
        >
          <Typography variant='h4'>
            {type
              ? `${type === 'gas' ? 'Gas' : 'Stock & Consumables'}: ${
                  code ?? ''
                }`
              : 'Please select a consumable type'}
          </Typography>
        </Grid>
        <Grid
          xs={0}
          md={4}
          item
          sx={{ borderBottom: '1px #c4c4c4 solid' }}
        ></Grid>

        <Grid xs={12} md={6} item>
          <ConsumablesTypeAutoComplete
            setByType={(data) => setType(data)}
            consumablesType={thisRowData.type}
            nameLabel='Consumable Type'
            id='consumablesType'
          />
        </Grid>

        <Grid xs={12} md={6} item>
          <TextField
            sx={{ width: '80%' }}
            id='code'
            code
            label='Code'
            variant='outlined'
            value={code}
            onChange={(event) => handleChange(event)}
          />
        </Grid>
        <Grid xs={12} md={12} item>
          <TextField
            sx={{ width: '90%' }}
            id='description'
            label='Description'
            variant='outlined'
            value={description}
            onChange={(event) => handleChange(event)}
          />
        </Grid>
      </Grid>

      <Divider sx={{ marginTop: '15px' }} />
      <Box align='right'>
        <Button
          variant='contained'
          onClick={handleSave}
          sx={{ margin: '15px 0 0 10px' }}
        >
          Save
        </Button>
        <Button
          variant='contained'
          color='secondary'
          onClick={cancelEdit}
          sx={{ margin: '15px 0 0 10px' }}
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
};

export default ConsumablesEdit;
const boxStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  borderRadius: '5px',
  boxShadow: 24,
  p: 4,
};

// const updateDtata = (uri, dataBlob) => {
//   const DataBlob = dataBlob;

//   //Get JWT from storage
//   let JWT = localStorage.getItem('JWT_Key');
//   //Set default Headers
//   let headers = {
//     'content-type': 'application/JSON',
//   };
//   //Set JWT in header if available
//   if (JWT) {
//     headers['x-api-key'] = JWT;
//   }
//   let body = {};

//   body = { consumable: DataBlob };
//   const request = new Request(`${APIROOT}/api${uri}`, {
//     method: 'post',
//     headers,
//     body: JSON.stringify(body),
//   });

//   fetch(request)
//     .then((response) => {
//       if (response.status === 200) {
//         return response.text();
//       } else {
//         throw new Error(`Failed to save serial`);
//       }
//     })
//     .then((data) => {
//       let parsed = JSON.parse(data);
//       if (parsed.success === true) {
//         setForceUpdate((val) => val + 1);
//         //Update JWT if required
//         if (parsed.JWT) {
//           localStorage.setItem('JWT_Key', parsed.JWT);
//         }
//         cancelEdit();
//         navigateBack(`/admin/consumables`, { replace: true });
//       } else {
//         //Force logout
//         if (parsed.message === 'Please login') {
//           logout(() => {
//             enqNotification('Session Expired', 'warning');
//           });
//         } else {
//           enqNotification(parsed.message, 'error');
//         }
//       }
//     })
//     .catch((error) => {
//       enqNotification(
//         typeof error == 'string' ? error : 'Connection Error',
//         'error'
//       );
//     });
// };
